import { useContext } from "react";
import { CurrentAccountContext } from "@/contexts/CurrentAccountContext";

export function useCurrentAccount() {
	const value = useContext(CurrentAccountContext);

	return value;
}
